import { PriceDiv } from '../B2G1RadioOption/styled';
import {
  LighteningDealRibbon,
  OfferCard,
  OfferName,
  PerDiaperPrice,
} from './styled';

export default function OfferSectionNew(props) {
  const { data, index, length } = props;
  return (
    <OfferCard lastElement={index === length - 1}>
      <div>
        <OfferName>{data?.offerName}</OfferName>
        {data?.isLimitedDeal && (
          <LighteningDealRibbon>{data?.limitedDeal}</LighteningDealRibbon>
        )}
      </div>
      <div>
        <PriceDiv>
          <strong>{data?.price}</strong>
          <span>{data?.strikePrice}</span>
        </PriceDiv>
        <PerDiaperPrice>{data?.perDiaperPrice}</PerDiaperPrice>
      </div>
    </OfferCard>
  );
}
